const TIDAL_TELEMETRY = "TIDAL_TELEMETRY";
const coverageRootId = "tidal-coverage-root";
const dsName = "tidal";
const modalZIndex = "1300";
const componentIdentityMap = {
  nonDs: 0,
  muiUnknown: 1,
  muiInput: 2,
  muiDataDisplay: 3,
  muiFeedback: 4,
  muiSurface: 5,
  muiNavigation: 6,
  muiLayout: 7,
  muiUtil: 8,
  tidalUnknown: 11,
  tidalInput: 12,
  tidalDataDisplay: 13,
  tidalFeedback: 14,
  tidalSurface: 15,
  tidalNavigation: 16,
  tidalLayout: 17,
  tidalUtil: 18
};
export {
  TIDAL_TELEMETRY,
  componentIdentityMap,
  coverageRootId,
  dsName,
  modalZIndex
};
//# sourceMappingURL=constants.js.map
